import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {accountingReport_template} from "../components/templates/accountingReport_template";
import {downloadCSV} from "../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";
import {header} from "./header";
import {accountingReportByRolegroup_template} from "../components/templates/accountingReportByRolegroup_template";

declare var ko: any;
declare var page: any;

export class accounting_report_by_rolegroup extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: accountingReportByRolegroup_template;

    protected getModuleName() {
        return "accounting_report_by_rolegroup";
    }

    buildContent(): Array<Element> {
        this.elementsList = new accountingReportByRolegroup_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Accounting Report By Role Group");
        return [this.elementsList.build()];
    }

    public fillPage(): void {
        this.getfilterReference();
    }



    protected filterSimpleOnChange() {

    }

    protected filterSimpleCancel() {

    }

    protected paymentListReorder() {
    }

    protected getfilterReference() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let element = document.getElementById("report-buttons-section")
        this.loadingIn(element);



        let usrReq_url: string;

        usrReq_url = '/api/transactions/references';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push();
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdl.requestId) {
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onGetfilterReferenceRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onGetfilterReferenceRequestReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateReferenceList(responseParsed.data);
            })
        }
    }


    protected updateReferenceList(responseParsed: any) {

        let payments = responseParsed.paymentDates;

        this.elementsList.setPaymentDateOptions(payments);
        this.elementsList.setClassifications(responseParsed.classifications);
        this.elementsList.setCompanies(responseParsed.companies);
        let currencies = [{id: 0, name:'All'}];
        responseParsed.currencies.filter( e => e.name = e.currency);
        Array.prototype.push.apply(currencies, responseParsed.currencies);
        console.log(currencies)
        this.elementsList.setCurrencies(currencies);


        // LOADING : ends
        let element = document.getElementById("report-buttons-section")
        this.loadingOut(element);
    }

    protected getReportByRoleGroup() {

        // LOADING : starts
        this.elementsList.builtTemplate.classList.add("loading");

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }


        let usrReq_url: string;
        usrReq_url = '/api/accounting/getReportByRoleGroup/';
        let vm = this.elementsList.getViewModelForRequest();

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON(vm)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReportByRoleGroupRequestReturn;
        this.XHRHdl.execute();

    }

    protected onGetReportByRoleGroupRequestReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data){
                    downloadCSV({filename: 'accounting_report_by_roleGroup-' + responseParsed.data.paymentDate + '.csv', data: responseParsed.data.report})
                } else {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                }
            })
            // LOADING : ends
            obj.elementsList.builtTemplate.classList.remove("loading");
        }
    }

    protected getAccrualReport() {

        // LOADING : starts
        this.elementsList.builtTemplate.classList.add("loading");

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }


        let usrReq_url: string;
        usrReq_url = '/api/accounting/getAccrualReport/';

        let vm = this.elementsList.getViewModelForRequest();

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON(vm)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetAccrualReportRequestReturn;
        this.XHRHdl.execute();

    }

    protected onGetAccrualReportRequestReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if(responseParsed.data) {
                    downloadCSV({filename: 'accounting_report_accrual_by_roleGroup-' + responseParsed.data.paymentDate + '.csv', data: responseParsed.data.report})
                } else {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                }

            })
            // LOADING : ends
            obj.elementsList.builtTemplate.classList.remove("loading");
        }
    }

    protected onUpdateError(requestStatus: any, responseParsed): void {
        let msg = "error: while obtaining the data - (" + requestStatus + ")";
        this.viewModel.list.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
        window.scrollTo(0, 0);
    }

    public getDataForExport(report) {

        if(report == 'accrualReport') {
            this.getAccrualReport();
        } else if(report == 'roleGroupReport'){
            this.getReportByRoleGroup();
        }
    }

    protected exportBalanceTransferToCSV() {

        // LOADING : starts
        this.elementsList.builtTemplate.classList.add("loading");

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }


        let usrReq_url: string;

        usrReq_url = '/api/valnet/payment/accounting/report/getBalanceTransfer';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetBalanceTransferReturn;
        this.XHRHdl.execute();

    }


    protected onGetBalanceTransferReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(  req.request.status == 200  ) {
                    obj.processBalanceTransfer(responseParsed.data.balanceTransfer, responseParsed.data.futureBalanceTransfers, responseParsed.data.paymentDate)
                }

                // LOADING : ends
                obj.elementsList.builtTemplate.classList.remove("loading");
            }
        }
    }

    private processBalanceTransfer(balanceTransfersCurrentPeriod, balanceTransfersNextPeriod, paymentDate){

        let balanceTransferData = [];

        for(let t of balanceTransfersCurrentPeriod){

            let r1 = [];
            r1["id"] = t["idUser"] + " Debits";
            r1["fullName"] = t["fullName"] + " Debits";
            r1["idCurrency"] = t["idCurrency"];
            r1["currentPeriodCAD"] =  t["totalDebitsCAD"];
            r1["currentPeriodUSD"] = t["totalDebitsUSD"];
            r1["currentPeriodGBP"] =  t["totalDebitsGBP"];
            r1["currentPeriodEUR"] = t["totalDebitsEUR"];
            r1["nextPeriodCAD"] = 0;
            r1["nextPeriodUSD"] = 0;
            r1["nextPeriodGBP"] = 0;
            r1["nextPeriodEUR"] = 0;
            balanceTransferData.push(r1);

            let r2 = [];
            r2["id"] = t["idUser"] + " Credits";
            r2["fullName"] = t["fullName"] + " Credits";
            r2["idCurrency"] = t["idCurrency"];
            r2["currentPeriodCAD"] =  t["totalCreditsCAD"];
            r2["currentPeriodUSD"] = t["totalCreditsUSD"];
            r2["currentPeriodGBP"] =  t["totalCreditsGBP"];
            r2["currentPeriodEUR"] = t["totalCreditsEUR"];
            r2["nextPeriodCAD"] = 0;
            r2["nextPeriodUSD"] = 0;
            r2["nextPeriodGBP"] = 0;
            r2["nextPeriodEUR"] = 0;
            balanceTransferData.push(r2);

        }

        for(let t of balanceTransfersNextPeriod){

            //check if user already exists
            let row1 = balanceTransferData.find(item => item.id === t["idUser"] + " Debits");
            if(row1){
                row1["nextPeriodCAD"] = t["totalDebitsCAD"];
                row1["nextPeriodUSD"] = t["totalDebitsUSD"];
                row1["nextPeriodGBP"] = t["totalDebitsGBP"];
                row1["nextPeriodEUR"] = t["totalDebitsEUR"];
            }else{
                let row1 = [];
                row1["id"] = t["idUser"] + " Debits";
                row1["fullName"] = t["fullName"] + " Debits";
                row1["idCurrency"] = t["idCurrency"];
                row1["currentPeriodCAD"] = 0;
                row1["currentPeriodUSD"] = 0;
                row1["currentPeriodGBP"] = 0;
                row1["currentPeriodEUR"] = 0;
                row1["nextPeriodCAD"] = t["totalDebitsCAD"];
                row1["nextPeriodUSD"] = t["totalDebitsUSD"];
                row1["nextPeriodGBP"] = t["totalDebitsGBP"];
                row1["nextPeriodEUR"] = t["totalDebitsEUR"];
                balanceTransferData.push(row1);

            }

            //check if user already exists
            let row2 = balanceTransferData.find(item => item.id === t["idUser"] + " Credits");
            if(row2){
                row2["nextPeriodCAD"] = t["totalCreditsCAD"];
                row2["nextPeriodUSD"] = t["totalCreditsUSD"];
                row2["nextPeriodGBP"] = t["totalCreditsGBP"];
                row2["nextPeriodEUR"] = t["totalCreditsEUR"];
            }else{
                let row2 = [];
                row2["id"] = t["idUser"] + " Credits";
                row2["fullName"] = t["fullName"] + " Credits";
                row2["idCurrency"] = t["idCurrency"];
                row2["currentPeriodCAD"] = 0;
                row2["currentPeriodUSD"] = 0;
                row2["currentPeriodGBP"] = 0;
                row2["currentPeriodEUR"] = 0;
                row2["nextPeriodCAD"] = t["totalCreditsCAD"];
                row2["nextPeriodUSD"] = t["totalCreditsUSD"];
                row2["nextPeriodGBP"] = t["totalCreditsGBP"];
                row2["nextPeriodEUR"] = t["totalCreditsEUR"];
                balanceTransferData.push(row2);

            }


        }

        if(balanceTransferData.length > 0) {

            let balanceTransferCSVData = [];

            //Push Heading Row
            balanceTransferCSVData.push({
                "Balance Transfers": "",
                " ": "",
                "CAD": "",
                "USD": "",
                "GBP": "",
                "EUR": "",
                "Beginning Balance": "",
                "Ending Balance": ""
            });

            let totalCADDebitsDifference = 0;
            let totalCADCreditsDifference = 0;
            let totalUSDDebitsDifference = 0;
            let totalUSDCreditsDifference = 0;
            let totalCADDifference = 0;
            let totalUSDDifference = 0;
            let totalGBPDebitsDifference = 0;
            let totalGBPCreditsDifference = 0;
            let totalEURDebitsDifference = 0;
            let totalEURCreditsDifference = 0;
            let totalGBPDifference = 0;
            let totalEURDifference = 0;
            let totalCurrentPeriodCreditsBalance = 0;
            let totalNextPeriodCreditsBalance = 0;
            let totalCurrentPeriodDebitsBalance = 0;
            let totalNextPeriodDebitsBalance = 0;
            let totalCurrentPeriodBalance = 0;
            let totalNextPeriodBalance = 0;


            for (let t of balanceTransferData) {
                let cadDifference = t["currentPeriodCAD"] - t["nextPeriodCAD"];
                let usdDifference = t["currentPeriodUSD"] - t["nextPeriodUSD"];
                let gbpDifference = t["currentPeriodGBP"] - t["nextPeriodGBP"];
                let eurDifference = t["currentPeriodEUR"] - t["nextPeriodEUR"];

                totalCADDifference += cadDifference;
                totalUSDDifference += usdDifference;
                totalGBPDifference += gbpDifference;
                totalEURDifference += eurDifference;

                let currentPeriodBalance = t["idCurrency"] == 1 ? t["currentPeriodUSD"] : t["currentPeriodCAD"];
                let nextPeriodBalance = t["idCurrency"] == 1 ? t["nextPeriodUSD"] : t["nextPeriodCAD"];

                totalCurrentPeriodBalance += Number(currentPeriodBalance);
                totalNextPeriodBalance += Number(nextPeriodBalance);

                if (t["id"].indexOf('Debits') !== -1) {

                    totalCADDebitsDifference += cadDifference;
                    totalUSDDebitsDifference += usdDifference;
                    totalEURDebitsDifference += eurDifference;
                    totalGBPDebitsDifference += gbpDifference;

                    totalCurrentPeriodDebitsBalance += Number(currentPeriodBalance);
                    totalNextPeriodDebitsBalance += Number(nextPeriodBalance);

                } else {

                    totalCADCreditsDifference += cadDifference;
                    totalUSDCreditsDifference += usdDifference;
                    totalEURCreditsDifference += eurDifference;
                    totalGBPCreditsDifference += gbpDifference;
                    totalCurrentPeriodCreditsBalance += Number(currentPeriodBalance);
                    totalNextPeriodCreditsBalance += Number(nextPeriodBalance);
                }


                balanceTransferCSVData.push({
                    "Balance Transfers": t["fullName"],
                    " ": "",
                    "CAD": '' + Number(cadDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "USD": '' + Number(usdDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "GBP": '' + Number(gbpDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "EUR": '' + Number(eurDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "Beginning Balance": '' + Number(currentPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                    "Ending Balance": '' + Number(nextPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                });

            }

            //empty line
            balanceTransferCSVData.push({
                "Balance Transfers": "",
                " ": "",
                "CAD": "",
                "USD": "",
                "GBP": "",
                "EUR": "",
                "Beginning Balance": "",
                "Ending Balance": "",
            });

            //total debits line
            balanceTransferCSVData.push({
                "Balance Transfers": "Balance Transfer Debits",
                " ": "",
                "CAD": '' + Number(totalCADDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "USD": '' + Number(totalUSDDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "GBP": '' + Number(totalGBPDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "EUR": '' + Number(totalEURDebitsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Beginning Balance": '' + Number(totalCurrentPeriodDebitsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Ending Balance": '' + Number(totalNextPeriodDebitsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
            });

            //total credits line
            balanceTransferCSVData.push({
                "Balance Transfers": "Balance Transfer Credits",
                " ": "",
                "CAD": '' + Number(totalCADCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "USD": '' + Number(totalUSDCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "GBP": '' + Number(totalGBPCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "EUR": '' + Number(totalUSDCreditsDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Beginning Balance": '' + Number(totalCurrentPeriodCreditsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Ending Balance": '' + Number(totalNextPeriodCreditsBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
            });

            //total line
            balanceTransferCSVData.push({
                "Balance Transfers": "TOTAL Balance Transfers",
                " ": "",
                "CAD": '' + Number(totalCADDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "USD": '' + Number(totalUSDDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "GBP": '' + Number(totalGBPDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "EUR": '' + Number(totalEURDifference).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Beginning Balance": '' + Number(totalCurrentPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
                "Ending Balance": '' + Number(totalNextPeriodBalance).toLocaleString(undefined, {minimumFractionDigits: 2}),
            });

                downloadCSV({filename: 'BalanceTransfer-' + paymentDate + '.csv', data: balanceTransferCSVData})
        } else {
            this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "No Data to export !");
            this.getVnAppZone().showNotificationToModule();
        }
    }

    public filterMultipleSelectorOnChange() {

    }

    public filterDropdownOnChange() {

    }
}



// WEBPACK FOOTER //
// ./js/modules/accounting_report_by_rolegroup.ts